import { FORM_ERROR } from 'final-form'
import {
  createValidator,
  ErrorObject,
  maxLength,
  required,
  richTextMaxLength,
  ValidatorFunction,
} from 'util/validation'

import { EncaminhamentoExternoEspecializadoModel } from '../model-encaminhamentoExterno'

export function encaminhamentoExternoFormValidator(
  encaminhamentosRecentes: ReadonlyArray<EncaminhamentoExternoEspecializadoModel>,
  encaminhamentoEditado?: EncaminhamentoExternoEspecializadoModel
): ValidatorFunction<EncaminhamentoExternoEspecializadoModel> {
  return createValidator<EncaminhamentoExternoEspecializadoModel>(
    {
      especialidadeSisreg: [required],
      classificacaoRiscoEncaminhamento: [required],
      motivoEncaminhamento: [richTextMaxLength(1000)],
      observacoes: [richTextMaxLength(300)],
      complemento: [maxLength(100)],
    },
    (values: EncaminhamentoExternoEspecializadoModel, errors: ErrorObject<EncaminhamentoExternoEspecializadoModel>) => {
      errors.cidEncaminhamento = required(values.cidEncaminhamento)

      encaminhamentosRecentes?.forEach((encaminhamentoSalvo) => {
        if (encaminhamentoEditado !== encaminhamentoSalvo) {
          const hipoteseDiagnosticoSalva = encaminhamentoSalvo.cidEncaminhamento?.codigo
          const hipoteseDiagnosticoInformada = values.cidEncaminhamento?.codigo

          if (
            encaminhamentoSalvo.especialidadeSisreg?.id === values.especialidadeSisreg?.id &&
            hipoteseDiagnosticoSalva === hipoteseDiagnosticoInformada
          ) {
            errors[FORM_ERROR] =
              'Já existe um encaminhamento cadastrado para esta Especialidade e Hipótese / Diagnóstico (CID10).'
          }
        }
      })

      return errors
    }
  )
}
